import * as React from 'react';
import { chartStyles, Config } from '../helpers';
import { Code } from 'react-content-loader';

export default function Preloader(props) {
  const {
    title
  } = props;
  const css = chartStyles('preview');

  return (
    <div className={css.root}>
      <div className='container'>
        <div className="row">
          <div className="col-lg-3">
            <div className='nv-chart__filters'>
              <div className='my-3'><Code/></div>
              <hr/>
              <div className='my-3'><Code/></div>
            </div>
          </div>
          <div className="col-lg-9">
            <div className="nv-chart__header">
              <h3 className='h--small my-0'>{title}</h3>
            </div>
            <div className="nv-chart__view">
              <div className="row">
                <div className="col-lg-4">
                  <Code/>
                </div>
                <div className="col-lg-4">
                  <Code/>
                </div>
                <div className="col-lg-4">
                  <Code/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export function LinesPreloader() {
  return (
    <div className="row">
      <div className="col-lg-4">
        <Code/>
      </div>
      <div className="col-lg-4">
        <Code/>
      </div>
      <div className="col-lg-4">
        <Code/>
      </div>
    </div>
  );
}
